<template>
  <article class="flightType inputSelect --sm --tag">
    <div class="inputSelect__group">
      <select class="inputSelect__input" v-model="internalValue" @change="$emit('change')">
        <option
          v-for="option of filteredOptions"
          :value="option.name"
        >
          {{ $t(option.label) }}
        </option>
      </select>
    </div>
  </article>
</template>

<script>
import flightTypeMixin from './mixins/mixin-flight-type'
export default {
  name: 'flightType',
  mixins: [flightTypeMixin]
}
</script>